
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteV as ObiOwnShipRemoteVElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-v.js';
 
 
 

 
 export const ObiOwnShipRemoteV = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-v',
   elementClass: ObiOwnShipRemoteVElement,
   events: {
     
   }
  });
 
 